export default __webpack_public_path__ + "525cd73f16ebcaff40110502192ad684.png";